/* -------------------------------------------------------------------------
   VENNER — Sección "Filas de características"
   Revela cada fila cuando entra en pantalla. Sólo marca clases: la
   animación en sí (desvanecer, subir, deslizar, acercar) vive en el CSS.
   ------------------------------------------------------------------------- */

if (!window.customElements.get('venner-feature-rows')) {
  class VennerFeatureRows extends HTMLElement {
    connectedCallback() {
      // El script se carga una vez por página: una sección en "Sin animación"
      // también pasa por aquí si otra de la misma página sí anima.
      if (this.dataset.animation === 'none') return;

      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            entry.target.classList.add('is-visible');
            this.observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -12% 0px' }
      );

      this.querySelectorAll('.vfr__row').forEach((row) => this.observer.observe(row));
      this.classList.add('is-ready');

      // En el editor, al elegir una fila en la barra lateral se muestra aunque
      // todavía no haya entrado en pantalla.
      this.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    onBlockSelect = (event) => {
      event.target.closest('.vfr__row')?.classList.add('is-visible');
    };
  }

  window.customElements.define('venner-feature-rows', VennerFeatureRows);
}
